import React from 'react';
import { Box, Typography, List, ListItemText, ListItemButton, Divider, Button } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { AddressListProps } from '../types/type';


export const AddressList: React.FC<AddressListProps> = ({
  addresses,
  selectedAddress,
  onSelectAddress,
  onNewAddress,
  onDeleteAddress,
  addressesWidth,
}) => {
  return (
    <Box sx={{
      width: addressesWidth,
      bgcolor: COLORS_ADMIN_PAGE.WHITE,
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      borderRight: `1px solid ${COLORS_ADMIN_PAGE.BORDER}`,
    }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        User Addresses
      </Typography>
      <List sx={{
        flex: 1,
        overflowY: 'auto',
        '&::-webkit-scrollbar': { width: '6px' },
        '&::-webkit-scrollbar-track': { background: '#f1f1f1' },
        '&::-webkit-scrollbar-thumb': { background: '#888', borderRadius: '3px' },
        '&::-webkit-scrollbar-thumb:hover': { background: '#555' },
      }}>
        {addresses.map((address, index) => (
          <React.Fragment key={address.addressId}>
            <ListItemButton
              selected={selectedAddress?.addressId === address.addressId}
              onClick={() => onSelectAddress(address)}
              sx={{
                borderRadius: '4px',
                mb: 1,
                '&.Mui-selected': {
                  bgcolor: COLORS_ADMIN_PAGE.PRIMARY,
                  color: COLORS_ADMIN_PAGE.WHITE,
                  '& .MuiListItemText-secondary': { color: 'rgba(255, 255, 255, 0.7)' },
                  '&:hover': { bgcolor: COLORS_ADMIN_PAGE.HOVER },
                },
              }}
            >
              <ListItemText
                primary={`${address.addresseeFirstName} ${address.addresseeMiddleName} ${address.addresseeLastName}`.trim()}
                secondary={
                  <Box component="span">
                    {address.street && (
                      <Typography variant="inherit" component="span" sx={{ fontSize: '12px' }}>
                        {address.street}
                      </Typography>
                    )},
                    {address.province.name && (
                      <Typography variant="inherit" component="span" sx={{ fontSize: '12px' }}>
                        {address.province.name}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </ListItemButton>
            {index < addresses.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
        <Button
          startIcon={<Add />}
          variant="contained"
          sx={{ color: 'white' }}
          onClick={onNewAddress}
        >
          NEW
        </Button>
        <Button
          startIcon={<Delete />}
          variant="contained"
          sx={{ color: 'white' }}
          onClick={onDeleteAddress}
          disabled={!selectedAddress}
        >
          DELETE
        </Button>
      </Box>
    </Box>
  );
};